import React from 'react';
import { Mic } from 'lucide-react';
import SmartTooltip from './SmartTooltip';

const VoiceInputButton = ({ onClick, disabled = false, hideTooltip = false }) => {
    const tooltipContent = (
        <>
            <div className="font-medium">Nhập bằng giọng nói</div>
            <div className="text-gray-400 mt-0.5">
                Ghi âm và chuyển thành văn bản
            </div>
        </>
    );

    return (
        <SmartTooltip content={tooltipContent} width="200px" disabled={disabled || hideTooltip}>
            <button
                onClick={onClick}
                className="w-7 h-7 flex items-center justify-center text-gray-500 hover:text-black hover:bg-app-hover rounded-full disabled:opacity-50 disabled:cursor-not-allowed bg-[#0d0d0d05] sm:bg-transparent"
                disabled={disabled}
                aria-label="Nhập bằng giọng nói"
            >
                <Mic className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </button>
        </SmartTooltip>
    );
};

export default VoiceInputButton;
